import { Head, Link } from "@inertiajs/react";
import { useState } from "react";

import { ProductCreationConfirmationDialog } from "@/components/product-creation-confirmation-dialog";
import { Button } from "@/components/ui/button";
import { ButtonGroup } from "@/components/ui/button-group";
import AppLayout from "@/layouts/app-layout";
import { productsPath } from "@/routes";
import type {
  BreadcrumbItem,
  PagyMetadata,
  Product,
  RansackFilters,
} from "@/types";

import { ProductsDataTable } from "./data-table";

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Productos",
    href: productsPath(),
  },
];

interface ProductsProps {
  data: {
    products: Product[];
    pagy: PagyMetadata;
  };
  filters: RansackFilters;
}

export default function Products({ data, filters }: ProductsProps) {
  const { products, pagy } = data;
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Productos" />
      <div className="flex h-full flex-1 flex-col gap-4 p-4">
        <div className="flex flex-col space-y-2">
          <h2 className="text-2xl font-bold">Productos</h2>
          <p className="text-muted-foreground">
            Gestiona el catálogo de productos y sus variantes
          </p>
        </div>

        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            Total: {pagy.count} productos
          </div>
          <ButtonGroup>
            <Button variant={"outline"} onClick={() => setIsDialogOpen(true)}>
              Crear Producto
            </Button>
            <Button asChild>
              <Link href="/products/import_new">Importar Excel</Link>
            </Button>
          </ButtonGroup>
        </div>

        <ProductsDataTable products={products} pagy={pagy} filters={filters} />
      </div>

      <ProductCreationConfirmationDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
      />
    </AppLayout>
  );
}
